var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BtnToggle',{attrs:{"title":_vm.$t('engine.manageText.modalWidget.tooltip.lblOutdent', _vm.languageEngine)},on:{"click":function($event){return _vm.onChange(_vm.value - 1)}}},[_c('i',{staticClass:"far fa-outdent fs-16"})])}
var staticRenderFns = []

export { render, staticRenderFns }